import { useCallback, useState } from 'react'

const STORAGE_KEY = 'ui.sidebarCollapsed'

const readStored = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/**
 * 記住側邊欄收合狀態（桌面版）。手機版不使用此狀態。
 */
export const useSidebarCollapsed = (): [boolean, (next: boolean) => void, () => void] => {
  const [collapsed, setCollapsedState] = useState<boolean>(() => readStored())

  const setCollapsed = useCallback((next: boolean) => {
    setCollapsedState(next)
    try {
      localStorage.setItem(STORAGE_KEY, next ? '1' : '0')
    } catch {
      // ignore
    }
  }, [])

  const toggle = useCallback(() => {
    setCollapsed(!collapsed)
  }, [collapsed, setCollapsed])

  return [collapsed, setCollapsed, toggle]
}
